import { useCallback } from "react"
import { useTranslation } from "react-i18next"
import { GraphQLTaggedNode, useMutation, UseMutationConfig } from "react-relay"
import { MutationParameters } from "relay-runtime"
import { toast } from "@/hooks/useToast"

export const useBetterDocMutation = <TMutation extends MutationParameters>(
  mutation: GraphQLTaggedNode,
): [(config: UseMutationConfig<TMutation>) => void, boolean] => {
  const [commit, isInFlight] = useMutation<TMutation>(mutation)
  const { t } = useTranslation()

  const commitWithErrorToast = useCallback(
    (config: UseMutationConfig<TMutation>) => {
      commit({
        ...config,
        onCompleted: (response, graphqlErrors) => {
          if (graphqlErrors?.length) {
            toast({ description: t("error.500.description") })
            config.onError?.(new Error(graphqlErrors[0].message))
            return
          }

          config.onCompleted?.(response, graphqlErrors)
        },
        onError: (error) => {
          toast({ description: t("error.500.description") })
          config.onError?.(error)
        },
      })
    },
    [commit, t],
  )

  return [commitWithErrorToast, isInFlight]
}
